export default function (mail) {
	var er = new RegExp(
		/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/
	);
	if (typeof mail == 'string') {
		if (er.test(mail)) {
			return true;
		}
	} else if (typeof mail == 'object') {
		if (er.test(mail.value)) {
			return true;
		}
	} else {
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/isMail.js